import { render, staticRenderFns } from "./searchCheguaIndex.vue?vue&type=template&id=3d2fd52a&scoped=true&"
import script from "./searchCheguaIndex.vue?vue&type=script&lang=js&"
export * from "./searchCheguaIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d2fd52a",
  null
  
)

export default component.exports